import Vue from 'vue'

export var messageBus = new Vue()